export const GATEWAY_REGISTRIES_RESET_STATE = 'GATEWAY_REGISTRIES_RESET_STATE';
export const GATEWAY_REGISTRIES_CURRENT_ITEM = 'GATEWAY_REGISTRIES_CURRENT_ITEM';

export const GATEWAY_REGISTRIES_REQUEST_LOADING = 'GATEWAY_REGISTRIES_REQUEST_LOADING';
export const GATEWAY_REGISTRIES_REQUEST_SUCCESS = 'GATEWAY_REGISTRIES_REQUEST_SUCCESS';
export const GATEWAY_REGISTRIES_REQUEST_FAILED = 'GATEWAY_REGISTRIES_REQUEST_FAILED';

export const GATEWAY_REGISTRIES_CURRENT_ACTION = 'GATEWAY_REGISTRIES_CURRENT_ACTION';
export const GATEWAY_REGISTRIES_RESET_ACTION = 'GATEWAY_REGISTRIES_RESET_ACTION';